"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListItem = _interopRequireDefault(require("@material-ui/core/ListItem"));

var _customProps = require("../../../../utils/customProps");

var _Storyblok = _interopRequireDefault(require("../../../../utils/Storyblok"));

var _MuiListItemAvatar = _interopRequireDefault(require("./components/MuiListItemAvatar/MuiListItemAvatar"));

var _MuiListItemIcon = _interopRequireDefault(require("./components/MuiListItemIcon/MuiListItemIcon"));

var _MuiListItemSecondaryAction = _interopRequireDefault(require("./components/MuiListItemSecondaryAction/MuiListItemSecondaryAction"));

var _MuiListItemText = _interopRequireDefault(require("./components/MuiListItemText/MuiListItemText"));

var _MuiContactButton = _interopRequireDefault(require("../../../MuiContactButton/MuiContactButton"));

var MuiListItem = function MuiListItem(_ref) {
  var rootClass = _ref.rootClass,
      alignItems = _ref.alignItems,
      dense = _ref.dense,
      disableGutters = _ref.disableGutters,
      divider = _ref.divider,
      selected = _ref.selected,
      contactButton = _ref.contactButton,
      listItemAvatar = _ref.listItemAvatar,
      listItemIcon = _ref.listItemIcon,
      listItemSecondaryAction = _ref.listItemSecondaryAction,
      listItemText = _ref.listItemText;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  var avatar = listItemAvatar[0];
  var icon = listItemIcon[0];
  var secondaryAction = listItemSecondaryAction[0];
  var text = listItemText[0];
  var contact = contactButton[0];
  return /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    className: styles.root,
    dense: dense,
    alignItems: alignItems,
    disableGutters: disableGutters,
    divider: divider,
    selected: selected
  }, avatar ? /*#__PURE__*/_react.default.createElement(_MuiListItemAvatar.default, avatar) : null, icon ? /*#__PURE__*/_react.default.createElement(_MuiListItemIcon.default, icon) : null, text ? /*#__PURE__*/_react.default.createElement(_MuiListItemText.default, text) : null, secondaryAction ? /*#__PURE__*/_react.default.createElement(_MuiListItemSecondaryAction.default, secondaryAction) : null, contact ? /*#__PURE__*/_react.default.createElement(_MuiContactButton.default, contact) : null);
};

var _default = MuiListItem;
exports.default = _default;
MuiListItem.propTypes = {
  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /** mui prop: 'flex-start', 'center'
   * Defines the align-items style property.
  */
  alignItems: function alignItems(props, propName, componentName) {
    var validProps = ['flex-start', 'center'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProps);
  },

  /** mui prop: true | false
   * If true, compact vertical padding designed for keyboard and mouse input will be used.
   * */
  dense: _propTypes.default.bool,

  /** mui prop: true | false
   * If true, the left and right padding is removed.
   * */
  disableGutters: _propTypes.default.bool,

  /** mui prop: true | false
   * If true, a 1px light border is added to the bottom of the list item.
   * */
  divider: _propTypes.default.bool,

  /** mui prop: true | false
   * Use to apply selected styling.
   * */
  selected: _propTypes.default.bool,

  /** MuiListItemAvatar Allowed maximum: 1 */
  listItemAvatar: function listItemAvatar(props, propName, componentName) {
    var components = ['MuiListItemAvatar'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** MuiListItemAvatar Allowed maximum: 1 */
  contactButton: function contactButton(props, propName, componentName) {
    var components = ['MuiListItemAvatar'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** MuiListItemIcon Allowed maximum: 1 */
  listItemIcon: function listItemIcon(props, propName, componentName) {
    var components = ['MuiListItemIcon'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  },

  /** MuiListItemText Allowed maximum: 1 */
  listItemText: function listItemText(props, propName, componentName) {
    return (0, _customProps.validComponentsRequired)(props, propName, componentName, ['MuiListItemText'], 1);
  },

  /** MuiListItemSecondaryAction Allowed maximum: 1 */
  listItemSecondaryAction: function listItemSecondaryAction(props, propName, componentName) {
    var components = ['MuiListItemSecondaryAction'];
    return (0, _customProps.validComponents)(props, propName, componentName, components, 1);
  }
};
MuiListItem.defaultProps = {
  alignItems: 'center',
  dense: false,
  disableGutters: false,
  divider: false,
  selected: false,
  rootClass: [],
  listItemAvatar: [],
  listItemIcon: [],
  listItemSecondaryAction: [],
  contactButton: [],
  listItemText: []
};